import React, { useState, useRef, useImperativeHandle } from "react";
import { Popconfirm, Tooltip, theme } from "antd";
import { DeleteOutlined, EditOutlined  } from "@ant-design/icons";
import TSTable from "../../common/TSTable";
import ColorButton from "../../common/ColorButton";
import { DELETE } from "../../frameworks/HttpClient";
import { URL_TRUCK } from "../../constants/urls";
import DailyPurchasingPriceListModal from "./DailyPurchasingPriceListModal";
import { dateTimeToHumanString, toHumanDate } from "../../frameworks/Util";
import ErrorMessages from "../../common/ErrorMessages";
import CustomDeleteConfirmButton from "../../common/CustomDeleteConfirmButton";
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
dayjs.extend(isSameOrAfter)

const DailyPurchasingPriceList = React.forwardRef((props, ref) => {
  const [
    openAddDailyPurchasingPriceModal,
    setOpenAddDailyPurchasingPriceModal,
  ] = useState(false);
  const [target, setTarget] = useState(null);
  const tableRef = useRef(null);
  const [errorMessages , setErrorMessages ] = useState(null);

  const {
    token: { colorWarning, colorError , colorSuccess },
  } = theme.useToken();

  useImperativeHandle(ref, () => ({
    fetchTable: refreshData,
  }));

  const refreshData = async () => {
    if (tableRef.current) {
      try {
        await tableRef.current.fetchWithoutResetPage();
      } catch (error) {
        setErrorMessages(error.errorMessages);
      }
    }
  };

  const handleEdit = (record) => {
    if (!record || !record.id) {
      return;
    }
    setTarget(record);
    setOpenAddDailyPurchasingPriceModal(true);
  };

  const handleDelete = async (id) => {
    try {
      await DELETE(`${URL_TRUCK.RAW_LATEX_PRICE_LIST}${id}/`);
      refreshData();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 200,
      key: "action",
      align: "center",
      render: (_, record) =>
        (
          <div onClick={(e) => e.stopPropagation()}>
            {/* <CustomDeleteConfirmButton
              title={`ยืนยันลบหรือไม่`}
              content={"ยืนยันการลบรายการนี้หรือไม่ ?"}
              onOk={ async() => {
                await handleDelete(record.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            /> */}
            {/* {dayjs(record.date).isSameOrAfter(dayjs(), 'day') && <Tooltip triger='hover' title="แก้ไขข้อมูล">
              <ColorButton
                type="primary"
                override={colorWarning}
                icon={<EditOutlined />}
                style={{ margin : 5}}
                onClick={() => handleEdit(record)}
              />
            </Tooltip>} */}
            <ColorButton
              type="primary"
              override={colorWarning}
              icon={<EditOutlined />}
              style={{ margin : 5}}
              onClick={() => handleEdit(record)}
            />
          </div>
        ),
    },
    {
      title: "วันที่",
      dataIndex: "date",
      key: "date",
      ellipsis: true,
      align: "center",
      render: (value) => toHumanDate(value)
    },
    {
      title: "ราคา (บาท/กิโลกรัม)",
      dataIndex: "price",
      key: "price",
      align: "center",
    },
    {
      title: "วันที่แก้ไขล่าสุด",
      dataIndex: "updated",
      key: "updated",
      align: "center",
      render: (value) => dateTimeToHumanString(value),
    },
  ];

  return (
    <div>
      <ErrorMessages message={errorMessages}/>
      <ColorButton
        type="primary"
        override={colorSuccess}
        // icon={<PlusCircleFilled />}
        style={{ marginBottom: 10, float: "right" }}
        onClick={() => setOpenAddDailyPurchasingPriceModal(true)}
      >
        + กำหนดราคา
      </ColorButton>
      <TSTable
        columns={columns}
        size="small"
        url={URL_TRUCK.RAW_LATEX_PRICE_LIST}
        ref={tableRef}
      />
      <DailyPurchasingPriceListModal
        open={openAddDailyPurchasingPriceModal}
        onClose={() => {
          setOpenAddDailyPurchasingPriceModal(false);
          setTarget(null);
        }}
        onUpdate={()=> {
          setOpenAddDailyPurchasingPriceModal(false);
          setTarget(null);
          refreshData();
        }}
        target={target}
      />
    </div>
  );
});

export default DailyPurchasingPriceList;
